import { Close } from '@mui/icons-material'
import { Fade, Stack, styled } from '@mui/material'
import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { useModal } from '../../store/app/hooks'
import { ModalMask } from '../../styles'
import { FaucetMain } from './FaucetMain'
import { updateModal } from '../../store/app/actions/modalActions'

const ModalWrap = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(5, 7, 20, 0.6);
  backdrop-filter: blur(4px);
  z-index: 300;
`

export const FaucetMainWrap = styled(Stack)`
  // overflow: hidden;
  width: 512px;
  background: ${(props) => props.theme.color?.bg};
  border-radius: 8px;
  padding: 24px 24px 0px;
  position: relative;
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
    bottom: 0;
    position: fixed;
    padding: 16px;
    border-radius: 8px 8px 0 0;
  }
`

const ButtonClose = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  padding: 13px 16px 13px 24px;
  cursor: pointer;
  font-size: 16px;
  line-height: 16px;
`
const FaucetTitle = styled('div')`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  /* Text Color/Light/100 */

  color: ${(props) => props.theme.color?.text100};
  margin-bottom: 24px;
`

export const FaucetModal = memo(() => {
  const dispatch = useDispatch()

  const openFaucetModal = useModal('faucet')

  const onClose = () => {
    dispatch(
      updateModal({
        modal: 'faucet',
        open: false,
      })
    )
  }
  return (
    <Fade in={openFaucetModal} timeout={200}>
      <ModalWrap>
        <ModalMask onClick={onClose}></ModalMask>

        <FaucetMainWrap>
          <ButtonClose onClick={onClose}>
            <Close
              sx={{
                width: 24,
                height: 24,
                color: '#9199B1',
                verticalAlign: 'top',
              }}
            />
          </ButtonClose>
          <FaucetTitle>Get test tokens</FaucetTitle>
          <FaucetMain />
        </FaucetMainWrap>
      </ModalWrap>
    </Fade>
  )
})
